import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutContainerComponent } from './layout-container.component';
import { VerticalModule } from './vertical/vertical.module';
import { LayoutSharedModule } from './shared/layout-shared.module';
import { RouterModule } from '@angular/router';
import { BoardMainScreenService } from '../pages/projects/board/board-main-screen/board-main-screen.service';



@NgModule({
  declarations: [
    LayoutContainerComponent,
  ],
  imports: [
    CommonModule,
    LayoutSharedModule,
    VerticalModule,
  ],
  exports: [LayoutContainerComponent],
})
export class LayoutModule { }
